import logo from './logo.svg';
import { vfIcon } from '../icon/icon.js';


/**
 * Viafoura Logo
 *
 * @data {"attrs": {"class": "vf-icon-large"}}
 * @styleguide components.icons.logo
 */
export const vfLogo = {
    extends: vfIcon,

    data() {
        return {
            name: 'vf-logo',
            graphics: logo,
            viewBox: '0 0 200 200',
        };
    },
};
